import { FileTypes } from 'common/constants/filetypes';

export function getFileSizeFormatted(size: number) {
  if (size >= 1000000000000000) {
    return `${Math.round(size / 1000000000000)} PB`;
  } else if (size >= 1000000000000) {
    return `${Math.round(size / 1000000000000)} TB`;
  } else if (size >= 1000000000) {
    return `${Math.round(size / 1000000000)} GB`;
  } else if (size >= 1000000) {
    return `${Math.round(size / 1000000)} MB`;
  } else if (size >= 1000) {
    return `${Math.round(size / 1000)} KB`;
  } else {
    return `${size} Bytes`;
  }
}

export function getFileLabelFromType(type: number) {
  switch (type) {
    case FileTypes.PDF:
      return 'PDF';
    case FileTypes.MP4:
      return 'Video';
    case FileTypes.URL:
      return 'URL';
    default:
      return 'Unknown';
  }
}
